export const QUESTION_TYPE = {
  AUTHOR: 'AuthorResponse',
  BARCODE: 'BarCodeResponse',
  CHECKBOX: 'CheckboxResponse',
  DATE_TIME: 'DateTimeResponse',
  EMPLOYEE: 'EmployeeResponse',
  EXPLODED_VIEW: 'ExplodedViewResponse',
  MEDIA: 'MediaResponse',
  NUMBER: 'NumberResponse',
  PADS_THICKNESS: 'PadsThicknessResponse',
  RADIO_BUTTON: 'RadioButtonResponse',
  REFERENCE: 'ReferenceResponse',
  SEVERITY: 'SeverityResponse',
  SIGNATURE: 'SignatureResponse',
  TEXTBOX: 'TextboxResponse',
  THICKNESS: 'ThicknessResponse',
  YES_NO: 'YesNoResponse',
  KPI: 'KPIResponse',
  BRAND: 'BrandResponse',
  MULTI_EMPLOYEE: 'MultiEmployeeResponse',
  TIRE_REPORT: 'TireReportResponse',
};

export const KPI_STATUSES = {
  NOK: 'NOK',
  OK: 'OK',
};
